import { Indicator } from '../../../Common/Charts/Indicator';
import { useAttentionChartsDataContext } from './hooks/useAttentionChartsDataContext';

export const CesareanBirths = () => {
    const { chartData } = useAttentionChartsDataContext();

    return (
        <Indicator
            title={'Indice de Partos Cesários'}
            indicatorValue={chartData?.indicators?.cesareanBirths}
            className='aligned-container'
            goalValue={15}
            goalMessage='Meta Aceitável - até 15%'
        />
    );
};
